import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faSearch,
    faStepForward,
    faStepBackward,
    faTimes,
    faPen,
    faCopy,
    faFile,
    faPlusCircle,
    faList,
    faSitemap,
    faBuilding,
    faShoppingBag,
    faClock,
    faGlobe,
    faListUl,
    faUser,
    faUpload,
    faEdit,
    faDesktop,
    faMobile,
    faPlus,
    faMinus,
    faMobileAlt,
    faPalette,
    faBookmark,
} from '@fortawesome/free-solid-svg-icons'


library.add(faSearch)
library.add(faStepForward)
library.add(faStepBackward)
library.add(faTimes)
library.add(faPen)
library.add(faCopy)
library.add(faFile)
library.add(faPlusCircle)
library.add(faList)
library.add(faSitemap)
library.add(faBuilding)
library.add(faShoppingBag)
library.add(faClock)
library.add(faGlobe)
library.add(faListUl)
library.add(faUser)
library.add(faUpload)
library.add(faEdit)
library.add(faDesktop)
library.add(faMobile)
library.add(faPlus)
library.add(faMinus)
library.add(faMobileAlt)
library.add(faPalette)
library.add(faBookmark)
